import React  from 'react';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { buildUrlAndOpenWindow } from '../../../../../utilities/StringHelpers/StringHelpers';


const Footer = (props) => {

  function onClickCompanyPrivacyPolicyLink(){
    buildUrlAndOpenWindow(props.companyPrivacyPolicyLink);
  }

  return (
    <>
      <footer className="electric-company-lead-block-footer">
        <BtnSubmit
                isBusiness={false}
                text={props.btnText}
                onclick={props.onclick}
                formid={props.formid}
                isDisplayWhatsAppIcon={props.isDisplayWhatsAppIcon}
              />
          {props.linkText && <a className='link-text' href="#" onClick={props.onClickLink}>{props.linkText}</a>}
          {props.companyPrivacyPolicyLink && <p className='legal-text'>הנתונים שיימסרו על ידך יישמרו במאגרי המידע של חברת {window.Config.brand_Name_HE} ישראל בע"מ שתעשה בהם שימוש בהתאם <a href='#' onClick={() => onClickCompanyPrivacyPolicyLink()}>למדיניות הפרטיות של החברה</a></p>}
      </footer>

    </>
  );
};

export default Footer;
